export default "__VITE_ASSET__Blm9TWtf__"